import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { RADIUS_TOKENS } from '../../../design-system/tokens/radius';

/**
 * Foundations › Radius — traslado del frame "Radius" de Figma (node 4-573).
 * Tabla Name | Propósito | Píxeles | Radius: cada fila muestra el token y un
 * preview con el redondeo aplicado. Header limpio (como Spacing/Shadows).
 *
 * Datos desde la fuente de verdad `RADIUS_TOKENS` (reusa `var(--radius-*)`).
 */
export const DSRadiusPage: React.FC = () => (
  <div className="px-10 py-12">
    <div className="mx-auto flex w-full max-w-[800px] flex-col gap-10">
      <PageHeader
        title="Radius"
        description="Usar valores de redondeado predefinidos para las esquinas de imágenes, botones u otros elementos de forma rápida y consistente, manteniendo el orden y la eficiencia."
      />

      <div className="w-full">
        {/* Head — mismo estilo que Spacing/Shadows (sin fondo, sólo borde inferior) */}
        <div className="flex items-center gap-8 border-b border-neutral-300 px-4 py-3 text-[14px] font-semibold text-neutral-900">
          <div className="w-[120px] shrink-0">Name</div>
          <div className="min-w-0 flex-1">Propósito</div>
          <div className="w-[64px] shrink-0">Píxeles</div>
          <div className="w-[110px] shrink-0">Radius</div>
        </div>

        {/* Filas */}
        {RADIUS_TOKENS.map((token) => (
          <div key={token.name} className="flex items-center gap-8 px-4 py-5">
            <div className="w-[120px] shrink-0">
              <code className="rounded bg-neutral-100 px-1.5 py-0.5 font-mono text-[13px] text-neutral-700">
                {token.name}
              </code>
            </div>
            <div className="min-w-0 flex-1 text-[16px] text-neutral-600">{token.purpose}</div>
            <div className="w-[64px] shrink-0 text-[15px] tabular-nums text-neutral-600">
              {token.pixels}
            </div>
            <div className="w-[110px] shrink-0">
              <div
                className="h-10 w-full border-2 border-neutral-400 bg-neutral-200"
                style={{ borderRadius: token.radius }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);
